import { Container, Stack, Box, Typography, CircularProgress } from '@mui/material';
import React from 'react';

interface NoManifestEntriesMessageProps {
  loading?: boolean;
}

const NoManifestEntriesMessage: React.FC<NoManifestEntriesMessageProps> = ({ loading }) => (
  <Container sx={{ mt: 1 }}>
    <Stack direction="row" spacing={2} sx={{ height: '10em' }}>
      <Box
        component="div"
        sx={{
          width: '100%',
          display: 'flex',
        }}
        justifyContent="center"
        alignItems="center"
      >
        {loading ? (
          <CircularProgress />
        ) : (
          <Typography variant="h4">
            This home doesn't have any manifest entries
          </Typography>
        )}
      </Box>
    </Stack>
  </Container>
);

export default NoManifestEntriesMessage; 